// Feature-local UI state types for the Overview block drawer flow.
// Keep domain/API block models in src/models/block.ts.
export enum BlockDrawerMode {
  // Triggered by clicking the "+" on any creatable lane to assign a new block.
  // "Creatable lane" (the ones with a plus button) at the moment are:
  // Nutrition, Mind-Gut and Behavior Change.
  Create = 'create',
  // Triggered by clicking an existing block card to view block details.
  Details = 'details',
  // Triggered by clicking an active goal block to edit its instructions.
  Edit = 'edit',
}

export type UserBlockAction = 'archive' | 'end';

export type FilterOption = {
  label: string;
  value: boolean;
};
